import React, { Component } from 'react'
import "./service.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiServiceList , getApiMsList } from "../../axios/api"
import { Pagination } from 'antd';
import 'antd/dist/antd.css';


export default class service extends Component {


    state = {

        serviceTypeList:[],
        list:[],
        list2:[],
        page:1,
        total:1,
        serviceType:0,

    }

    componentWillMount(){
        window.scroll(0,0);

        this.changePage(1);
    }

    componentDidMount(){
       
    }

    getService=()=>{

        
    }

    getList=()=>{

        let param = {
            page:this.state.page
        }

        if(this.state.serviceType === 0){
            getApiServiceList(param)
            .then( req =>{
                if(req.data.code === 1){
    
                    let data = req.data.data;
    
                    this.setState({
                        list:data.list,
                        total:data.total
                    })
                }
            }).catch( err =>{
                console.error(err);
            })
        }else{
            getApiMsList(param)
            .then( req =>{
                if(req.data.code === 1){
    
                    let data = req.data.data;
    
                    this.setState({
                        list2:data.list,
                        total:data.total
                    })
                }
            }).catch( err =>{
                console.error(err);
            })
        }
    }
    

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    gotoInfoPage=(page)=>{
 
        let str = window.location.href;
        var num=str.indexOf("#/") 
        str=str.substr(0,num+1); //取得所有参数   stringvar.substr(start [, length ]

        window.open(str + page);
    }

    changePage=(page)=>{
        this.setState({
            page
        })

        setTimeout(()=>{
            this.getList();
        },100)
    }

    changeTypeValue=(name,data)=>{
        let param = this.state.param;
        param[name] = data.value;
        this.setState({
            param
        })

        this.changePage(1);
    }

    render() {
        return (
            <div className='service'>
                <Header type={4} />

                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>服务大厅</p>
                            </div>

                            <div className='hbox'>
                                <div className='hdiv'>
                                    <h2>所属分类：</h2>
                                    <div className='hflex'>
                                        {/* <div onClick={()=>{this.setState({serviceType:''});this.getService()}} className={this.state.serviceType === ''?"chosn":""}>全部</div> */}
                                        {/* {
                                            this.state.serviceTypeList.map((item,index)=>{
                                                return <div key={index} onClick={()=>{this.setState({serviceType:item.id});this.getService()}} className={this.state.serviceType === item.id?"chosn":""}>{item.title}</div>
                                            })
                                        } */}

                                        <div onClick={()=>{this.setState({serviceType:0});this.changePage(1)}} className={this.state.serviceType === 0?'chosn':""} style={this.state.serviceType === 0?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                            <p>科技服务</p>
                                        </div>
                                        <div onClick={()=>{this.setState({serviceType:1});this.changePage(1)}} className={this.state.serviceType === 1?'chosn':""} style={this.state.serviceType === 1?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                            <p>投资机构</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='box' hidden={this.state.serviceType === 1}>
                                {
                                    this.state.list.map((item,index)=>{
                                        return <div key={index}>
                                                <div className='card'>
                                                    <div className='cbox'>
                                                            <div className='cimg' style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                                            <div className='ctext'>
                                                                <h2>{item.title}</h2>
                                                                <p>服务类型：{item.industrial}</p>
                                                            </div>
                                                        </div>
                                                        <div className='cbom'>
                                                            <img className='cimg' alt="" src="/www/assets/imgs/shangjia.png" />
                                                            <h2>科服易站服务商</h2>
                                                        </div>
                                                        <div className='mark'>
                                                            <div className='mleft'>
                                                                <img alt="" className='mimg' src={item.qrcode} />
                                                                <h2>扫一扫关注服务站</h2>
                                                            </div>
                                                            <div className='minfo'>
                                                                <h2>{item.title}</h2>
                                                                <p>科服易站服务商</p>
                                                                <div>{item.info}</div>
                                                            </div>
                                                        </div>
                                                </div>
                                        </div>
                                    })
                                }
                                
                            </div>
                            <div className='box' hidden={this.state.serviceType === 0}>
                                {
                                    this.state.list2.map((item,index)=>{
                                        return <div key={index}>
                                                    <div className='card'>
                                                        <div className='cbox'>
                                                            <div className='cimg' style={{backgroundImage:"url('"+item.logo_text+"')"}}></div>
                                                            <div className='ctext'>
                                                                <h2>{item.nickname}</h2>
                                                                <p>机构性质：{item.nature}</p>
                                                                <p>成立时间：{item.esta_time}</p>
                                                            </div>
                                                        </div>
                                                        <div className='cbom'>
                                                            <img className='cimg' alt="" src="/www/assets/imgs/dingwei.png" />
                                                            <h2>{item.mechanism}</h2>
                                                            <div onClick={()=>{this.gotoInfoPage('/serviceinfo?id='+item.id)}}>
                                                                <p>查看详情</p>
                                                                <img alt="" src="/www/assets/imgs/chakanxiangqing.png" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                    })
                                }
                                
                            </div>
                            <div className='r_page'>
                                <Pagination type="success" showSizeChanger={false} pageSize={9}  defaultCurrent={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                            </div>
                        </div>
                    </div>
                </div>

                

                <Footer />
            </div>
        )
    }
}
